/*
 * Copyright (C) 2023 Airfordable, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import 'whatwg-fetch';

import * as Sentry from '@sentry/gatsby';

import { isProduction } from 'utils/constants';

const oneLinkURL = isProduction
  ? 'https://go.airfordable.com/uvl5/n0xrjfzq'
  : 'https://go.airfordable.com/2VFB';
const mediaSource = { defaultValue: 'SMS', keys: ['utm_source'] };
const channel = { keys: ['utm_channel'] };
const campaign = { keys: ['utm_campaign'] };
const ad = { keys: ['utm_ad'] };
const custom_ss_ui = { defaultValue: 'true', paramKey: 'af_ss_ui' };

/**
 * Creates an AppsFlyer OneLink for downloading the app.
 *
 * @param postHogUserId The PostHog user ID.
 * @returns The dynamic download link.
 */
function createDynamicDownloadLink(
  postHogUserId: string | undefined
): string | undefined {
  if (typeof window === 'undefined' || window == null) return undefined;

  // Generate an AppsFlyer OneLink URL.
  const result = window.AF_SMART_SCRIPT?.generateOneLinkURL({
    afParameters: {
      ad,
      afCustom: [custom_ss_ui],
      campaign,
      channel,
      deepLinkValue: {
        defaultValue: postHogUserId && `ph_id_${postHogUserId}`,
        keys: ['deep_link_value'],
      },
      mediaSource,
    },
    oneLinkURL,
  });

  if (!result?.clickURL) {
    Sentry.captureException(
      'Failed to generate AppsFlyer onelink, returning default onelink URL'
    );
    return oneLinkURL;
  }

  return result.clickURL;
}

export { createDynamicDownloadLink };
